import BunkeyAPI from "../api/BunkeyAPI";
import {
  USERS,
  USERS_SUCCESS,
  USERS_FAILURE,
  USERS_ADD,
  USERS_ADD_RESET,
  USERS_ADD_SUCCESS,
  USERS_ADD_FAILURE,
  USERS_ALL_DATA,
  USERS_SUCCESS_ALL_DATA,
  USERS_FAILURE_ALL_DATA,
  USERS_INVITATION_ADD,
  USERS_INVITATION_ADD_SUCCESS,
  USERS_INVITATION_ADD_FAILURE,
  USERS_EDIT,
  USERS_EDIT_SUCCESS,
  USERS_EDIT_FAILURE,
  USERS_EDIT_SELECT,
  USERS_EDIT_UNSET_SELECT,
  USERS_DELETE,
  USERS_DELETE_SUCCESS,
  USERS_DELETE_FAILURE,
  USERS_EXISTS,
  USERS_EXISTS_RESET,
  USERS_EXISTS_SUCCESS,
  USERS_EXISTS_FAILURE,
  USERS_CHANGE_PASSWORD_SELECT,
  USERS_CHANGE_PASSWORD_UNSET_SELECT,
  USERS_CHANGE_PASSWORD,
  USERS_CHANGE_PASSWORD_SUCCESS,
  USERS_CHANGE_PASSWORD_FAILURE,
  APP_DRAWER_ENABLED,
  USERS_EXIST_GROUP,
  USERS_EXIST_GROUP_SUCCESS,
  USERS_EXIST_GROUP_FAILURE
} from "../constants/users-types";
import { sendNotification } from "../utils";
import moment from "moment";
import store from "../store";

export const getUsers = (
  workclient,
  page = 1,
  criteria = null,
  allInfo = false
) => {
  return dispatch => {
    dispatch({ type: USERS });
    BunkeyAPI({
      url: criteria
        ? `clients/${workclient}/workspaces?page=${page}&criteria=${criteria}`
        : allInfo
          ? `clients/${workclient}/workspaces?page=${page}&allInfo=${allInfo}`
          : `clients/${workclient}/workspaces?page=${page}`,
      method: "GET"
    })
      .then(resp => {
        const users = resp.data.map(r => {
          let clientRoleTrad = null;
          let roleLower = null;
          if (r.role === "admin" && r.clientRole === "admin") {
            clientRoleTrad = "Súper admin";
            roleLower = "superadmin";
          } else if (r.clientRole === "admin") {
            clientRoleTrad = "Administrador";
            roleLower = "admin";
          } else {
            clientRoleTrad = "Operador";
            roleLower = "operator";
          }
          return {
            ...r,
            clientRoleTrad,
            roleLower,
            typeRoleFilter: r.userType ? r.userType : "Infinite",
            // clientRoleTrad: r.role === 'admin' && r.clientRole === 'admin'
            //   ? 'Súper admin'
            //   : r.clientRole === 'admin' ? 'Administrador' : 'Operador',
            createdAtFormat: r.createdAt
              ? moment(r.createdAt).format("YYYY-MM-DD")
              : "",
            dueDateFormat: r.dueDate
              ? moment(r.dueDate).format("YYYY-MM-DD")
              : ""
          };
        });
        dispatch({
          type: USERS_SUCCESS,
          payload: {
            data: users,
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: USERS_FAILURE,
          payload: err
        });
      });
  };
};

export const getFilterUsers = () => {
  return dispatch => {
    dispatch({ type: USERS_ALL_DATA });
    BunkeyAPI({
      url: `/users/getusers`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: USERS_SUCCESS_ALL_DATA,
            payload: {
              allUsers: resp.data,
              headers: resp.headers
            }
          });
        }
      })
      .catch(err => {
        dispatch({
          type: USERS_FAILURE_ALL_DATA,
          payload: err
        });
      });
  };
};

// export const createUser = (userExistsUserId, name, emailLowerCase, password, role, workClient, justAddWorkClient, group, userType, initDate, dueDate) => {
//   const email = emailLowerCase.toLowerCase()
//   return dispatch => {
//     dispatch({ type: USERS_ADD })
//     if (justAddWorkClient) {
//       if (group.length > 0) {
//         BunkeyAPI({
//           url: `groups/user/${userExistsUserId}/group/${group}`,
//           method: 'POST'
//         }).then(resp0 => {
//           dispatch(createNewUser(userExistsUserId, role, workClient))
//         })
//       } else {
//         dispatch(createNewUser(userExistsUserId, role, workClient))
//       }
//     } else {
//       const format = 'YYYY-MM-DD'
//       const initDateMoment = moment(initDate, format);
//       const dueDateMoment = moment(dueDate, format);
//       initDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
//       dueDateMoment.set({ hour: 23, minute: 59, second: 59, millisecond: 999 })

//       BunkeyAPI({
//         url: `users`,
//         method: 'POST',
//         data: {
//           name,
//           email,
//           avatar: '',
//           role: role !== 'admin'
//             ? 'operator'
//             : 'admin',
//           status: true,
//           workClients: role !== 'admin'
//             ? [workClient]
//             : [],
//           password,
//           group,
//           userType,
//           initDate: initDateMoment,
//           // initDateObj.setUTCHours(0, 0, 0, 0),
//           dueDate: dueDateMoment
//           // dueDateObj.setUTCHours(23, 59, 59, 999)
//         }
//       }).then(resp1 => {
//         if (resp1.status === 201) {
//           BunkeyAPI({
//             url: `users/${resp1.data._id}/clients/${workClient}/workspace`,
//             method: 'POST'
//           }).then(resp2 => {
//             if (resp2.status === 200) {
//               if (role === 'clientAdmin') {
//                 BunkeyAPI({
//                   url: `users/${resp1.data._id}/workspaces/${workClient}?noUpdateRole=true`,
//                   method: 'PUT',
//                   data: {
//                     action: 'updateRole',
//                     role: 'admin',
//                   }
//                 }).then(resp3 => {
//                   if (resp3.status === 204) {
//                     dispatch({
//                       type: USERS_ADD_SUCCESS,
//                       payload: {
//                         newUser: resp1.data
//                       }
//                     })
//                   } else {
//                     dispatch({ type: USERS_ADD_FAILURE })
//                   }
//                 }).catch(err => {
//                   dispatch({ type: USERS_ADD_FAILURE })
//                 })
//               } else {
//                 dispatch({
//                   type: USERS_ADD_SUCCESS,
//                   payload: {
//                     newUser: resp1.data
//                   }
//                 })
//               }
//             } else {
//               dispatch({ type: USERS_ADD_FAILURE })
//             }
//           }).catch(err => {
//             dispatch({ type: USERS_ADD_FAILURE })
//           })

//         } else {
//           dispatch({ type: USERS_ADD_FAILURE })
//         }
//       }).catch(err => {
//         dispatch({ type: USERS_ADD_FAILURE })
//       })
//     }
//   }
// }

export const createUser = (
  name,
  email,
  password,
  role,
  workClient,
  groups,
  userType,
  initDate,
  dueDate,
  message
) => {
  const { data: client } = store.getState().client;
  const emailLowerCase = email.toLowerCase();
  let { byClientData } = store.getState().group;
  byClientData = byClientData
    .filter(group => groups.includes(group._id))
    .map(group => {
      return { _id: group._id, name: group.name };
    });

  return dispatch => {
    dispatch({ type: USERS_ADD });
    const format = "YYYY-MM-DD";
    const initDateMoment = moment(initDate, format);
    const dueDateMoment = moment(dueDate, format);
    initDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    dueDateMoment.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    const data =
      byClientData && byClientData.length > 0
        ? {
          name,
          email: emailLowerCase,
          avatar: "",
          role: role === "admin" ? "admin" : "operator",
          roleWorkSpace: role === "clientAdmin" ? "clientAdmin" : "operator",
          status: true,
          workClients: role !== "admin" ? [workClient] : [],
          password,
          message,
          client,
          groups: byClientData,
          userType,
          initDate: initDateMoment,
          dueDate: dueDateMoment
        }
        : {
          name,
          email: emailLowerCase,
          avatar: "",
          // role: role !== 'admin'
          //   ? 'operator'
          //   : 'admin',
          role: role === "admin" ? "admin" : "operator",
          roleWorkSpace: role === "clientAdmin" ? "clientAdmin" : "operator",
          status: true,
          workClients: role !== "admin" ? [workClient] : [],
          password,
          message,
          client,
          userType,
          initDate: initDateMoment,
          dueDate: dueDateMoment
        };

    BunkeyAPI({
      url: `users/new-user`,
      method: "POST",
      data
    })
      .then(response => {
        dispatch(getUsers(workClient, 1, null, true));
        dispatch({
          type: USERS_ADD_SUCCESS,
          payload: {
            newUser: response.data
          }
        });
      })
      .catch(err => {
        dispatch({ type: USERS_ADD_FAILURE });
      });
  };
};

export const newInvitation = (
  email,
  role,
  workClient,
  groups,
  userType,
  initDate,
  dueDate,
  message,
  handleHiddenAddModalUser
) => {
  const { data: client } = store.getState().client;
  let { byClientData } = store.getState().group;
  const groupsToFilter = groups.length > 0 ? groups : [byClientData[0]._id];
  const groupsWithIdName = byClientData
    .filter(group => groupsToFilter.includes(group._id))
    .map(group => {
      return { _id: group._id, name: group.name };
    });

  return dispatch => {
    dispatch({ type: USERS_ADD });
    const format = "YYYY-MM-DD";
    const initDateMoment = moment(initDate, format);
    const dueDateMoment = moment(dueDate, format);
    initDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    dueDateMoment.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    const data = {
      email: email.toLowerCase(),
      role: role === "admin" ? "admin" : "operator",
      roleWorkSpace: role === "clientAdmin" ? "clientAdmin" : "operator",
      status: true,
      workClients: role !== "admin" ? workClient : null,
      message,
      client: { _id: client._id, name: client.name },
      groups: groupsWithIdName,
      userType,
      initDate: initDateMoment,
      dueDate: dueDateMoment
    };

    BunkeyAPI({
      url: `users/new-invitation`,
      method: "POST",
      data
    })
      .then(response => {
        dispatch(getUsers(workClient, 1, null, true));
        dispatch({
          type: USERS_ADD_SUCCESS,
          payload: {
            newUser: response.data
          }
        });
        if (handleHiddenAddModalUser) {
          handleHiddenAddModalUser();
        }
      })
      .catch(err => {
        dispatch({ type: USERS_ADD_FAILURE });
      });
  };
};

export const createNewUser = (userExistsUserId, role, workClient) => {
  return dispatch => {
    BunkeyAPI({
      url: `users/${userExistsUserId}/workclient/${workClient}`,
      method: "PUT"
    })
      .then(resp1 => {
        if (resp1.status === 200) {
          if (role === "clientAdmin") {
            BunkeyAPI({
              url: `users/${resp1.data.user}/workspaces/${workClient}`,
              method: "PUT",
              data: {
                action: "updateRole",
                role: "admin"
              }
            })
              .then(resp3 => {
                if (resp3.status === 204) {
                  dispatch({
                    type: USERS_ADD_SUCCESS,
                    payload: {
                      newUser: resp3.data
                    }
                  });
                } else {
                  dispatch({ type: USERS_ADD_FAILURE });
                }
              })
              .catch(err => {
                dispatch({ type: USERS_ADD_FAILURE });
              });
          } else {
            dispatch({
              type: USERS_ADD_SUCCESS,
              payload: {
                newUser: resp1.data
              }
            });
          }
        } else {
          dispatch({ type: USERS_ADD_FAILURE });
        }
      })
      .catch(err => {
        dispatch({ type: USERS_ADD_FAILURE });
      })
      .catch(err => {
        dispatch({ type: USERS_ADD_FAILURE });
      });
  };
};

export const createUserAlreadyExist = (userId, idClient, role) => {
  return dispatch => {
    dispatch({ type: USERS_EXIST_GROUP });
    BunkeyAPI({
      url: `users/${userId}/workclientModify/${idClient}`,
      method: "PUT",
      data: {
        role: role
      }
    })
      .then(resp => {
        dispatch({
          type: USERS_EXIST_GROUP_SUCCESS,
          payload: {
            status: "UserAlreadyExist",
            newUser: resp.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: USERS_EXIST_GROUP_FAILURE,
          payload: err
        });
      });
  };
};

export const userAddReset = () => {
  return dispatch => {
    dispatch({ type: USERS_ADD_RESET });
  };
};

export const userExistsReset = () => {
  return dispatch => {
    dispatch({ type: USERS_EXISTS_RESET });
  };
};

export const userExistsByEmail = (workclient, email) => {
  return dispatch => {
    dispatch({ type: USERS_EXISTS });
    BunkeyAPI({
      url: `users/validate`,
      method: "POST",
      data: {
        email
      }
    })
      .then(resp => {
        if (resp.data.code === "UserNotFound") {
          dispatch({
            type: USERS_EXISTS_SUCCESS,
            payload: {
              status: "UserNotFound"
            }
          });
        } else {
          dispatch({
            type: USERS_EXISTS_SUCCESS,
            payload: {
              status: "UserAlreadyExist",
              profile: resp.data.role,
              userId: resp.data._id,
              workclientAlreadyDone: resp.data.workClients.includes(workclient)
            }
          });
        }
      })
      .catch(err => {
        dispatch({
          type: USERS_EXISTS_FAILURE,
          payload: err
        });
      });
  };
};

export const invitationUser = (
  name,
  email,
  workclient,
  message,
  groups,
  userType,
  initDate,
  dueDate
) => {
  return dispatch => {
    const format = "YYYY-MM-DD";
    const initDateMoment = moment(initDate, format);
    const dueDateMoment = moment(dueDate, format);
    initDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    dueDateMoment.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    dispatch({ type: USERS_INVITATION_ADD });

    BunkeyAPI({
      url: `invitations`,
      method: "POST",
      data: {
        fullname: name,
        email,
        client: workclient,
        message: message,
        userType,
        initDate: initDateMoment,
        dueDate: dueDateMoment,
        groups
      }
    })
      .then(resp => {
        if (resp.status === 204) {
          dispatch({ type: USERS_INVITATION_ADD_SUCCESS });
        } else {
          dispatch({
            type: USERS_INVITATION_ADD_FAILURE,
            payload: resp
          });
        }
      })
      .catch(err => {
        dispatch({
          type: USERS_INVITATION_ADD_FAILURE,
          payload: err
        });
      });
  };
};

export const editUser = (
  workClient,
  userId,
  role,
  status,
  modalNews,
  name,
  dateAttempsBlock,
  groups
) => {
  let { byClientData } = store.getState().group;
  byClientData = byClientData
    .filter(group => groups.includes(group._id))
    .map(group => {
      return { _id: group._id, name: group.name };
    });
  const data =
    byClientData && byClientData.length > 0
      ? {
        action: "updateRole",
        role: role,
        status,
        modalNews,
        name,
        dateAttempsBlock,
        groups: byClientData
      }
      : {
        action: "updateRole",
        role: role,
        status,
        modalNews,
        name,
        dateAttempsBlock
      };

  return dispatch => {
    dispatch({ type: USERS_EDIT });
    BunkeyAPI({
      url: `users/${userId}/workspaces/${workClient}`,
      method: "PUT",
      data: data
    })
      .then(resp => {
        dispatch({
          type: USERS_EDIT_SUCCESS,
          payload: {
            id: userId,
            role: role
          }
        });
        dispatch(getUsers(workClient, 1, null, true));
      })
      .catch(err => {
        dispatch({
          type: USERS_EDIT_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const deleteUser = (workClient, userId) => {
  return dispatch => {
    dispatch({ type: USERS_DELETE });
    BunkeyAPI({
      url: `users/${userId}/workspaces/${workClient}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 204) {
          dispatch({ type: USERS_DELETE_SUCCESS });
        } else {
          dispatch({ type: USERS_DELETE_FAILURE });
        }
      })
      .catch(err => {
        dispatch({
          type: USERS_DELETE_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const setSelectUserEdit = id => {
  return dispatch => {
    dispatch({
      type: USERS_EDIT_SELECT,
      payload: {
        _id: id
      }
    });
  };
};

export const unsetSelectUserEdit = () => {
  return dispatch => {
    dispatch({
      type: USERS_EDIT_UNSET_SELECT,
      payload: {}
    });
  };
};

export const setSelectUserChangePassword = id => {
  return dispatch => {
    dispatch({
      type: USERS_CHANGE_PASSWORD_SELECT,
      payload: {
        _id: id
      }
    });
  };
};

export const unsetSelectUserChangePassword = () => {
  return dispatch => {
    dispatch({
      type: USERS_CHANGE_PASSWORD_UNSET_SELECT,
      payload: {}
    });
  };
};

export const changePasswordUser = (id, password, intl) => {
  return dispatch => {
    dispatch({ type: USERS_CHANGE_PASSWORD });
    BunkeyAPI({
      url: `users/${id}/resetPassword`,
      method: "POST",
      data: {
        password
      }
    })
      .then(resp => {
        if (resp.status === 200 && resp.data === "OK") {
          sendNotification(
            "success",
            intl,
            intl.formatMessage({ id: "password_changed_success" })
          );
          dispatch({ type: USERS_CHANGE_PASSWORD_SUCCESS });
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "try_again" })
          );
          dispatch({ type: USERS_CHANGE_PASSWORD_FAILURE });
        }
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "try_again" })
        );
        dispatch({
          type: USERS_CHANGE_PASSWORD_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const handlingDrawer = isEnabled => {
  return dispatch => {
    dispatch({ type: APP_DRAWER_ENABLED, payload: isEnabled });
  };
};

export const editStatusUser = (workClient, userId, status) => {
  return dispatch => {
    BunkeyAPI({
      url: `users/${userId}`,
      method: "PUT",
      data: {
        status
      }
    })
      .then(resp => {
        dispatch(getUsers(workClient, 1, null, true));
      })
      .catch(err => { });
  };
};
